export default __webpack_public_path__ + "static/turbo-console-7f73a9e0a69cd89d5a6558c890359a26.png";